globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modals = appCustomerSpace.Modals || {};
appCustomerSpace.Modals.Websites = appCustomerSpace.Modals.Websites || {};

appCustomerSpace.Modals.Websites.ShareArticle = (function(superClass) {

  utils.extend(ShareArticle, superClass);

  function ShareArticle($html) {
    this.$html = $html;

    return ShareArticle.__super__.constructor.apply(this, arguments);
  }

  $.extend(ShareArticle.prototype, {
    init: function() {
      ShareEvents.initEvents(this.$html);
      this.initEvents();

      return ShareArticle.__super__.init.apply(this, arguments);
    },
    initEvents: function() {
      $(document).on('clipboard.success', function(e, $trigger) {
        if(!$trigger.data('bs.tooltip')) $trigger.tooltip();
        $trigger.attr('data-original-title', 'Copié !').tooltip('show').trigger('mouseenter');
      }).on('clipboard.error', function() {
        if(!$el.data('bs.tooltip')) $trigger.tooltip();
        $trigger.attr('data-original-title', 'Erreur lors de la copie...').tooltip('show').trigger('mouseenter');
      });
    }
  });

  return ShareArticle;

})(appCustomerSpace.Modal);
